import { useEffect, useRef, useState } from 'react'
import { AutoComplete, type AutoCompleteProps } from 'primereact/autocomplete'

/**
 * `AutoComplete` karşılığı — bkz. `MobileSheetDropdown` (aynı karartma/kaydırma-kilidi kablolaması,
 * gerekçe orada).
 *
 * <p>Dropdown'daki AYNI gecikme sorunu burada da vardı: PrimeReact paneli `suggestions` prop'u boştan
 * doluya geçtiği an açmaya BAŞLAR (bkz. `autocomplete.esm.js` `useEffect([props.suggestions])` →
 * `show()`), ama `onShow` yalnız geçiş ANİMASYONU bittikten SONRA tetiklenir (`onOverlayEntered`) —
 * karartmayı `onShow`'a bağlarsak alttan açılan panelden gözle görülür bir gecikmeyle belirir (kullanıcı
 * bildirimi 2026-08-29). Çözüm Dropdown'daki `onClick` numarasıyla AYNI fikir: karartmayı animasyonun
 * BAŞLADIĞI ana bağlamak — burada tetikleyici tıklama değil `suggestions` referansının değişmesidir
 * (PrimeReact panelin kendi açma kararını verdiği an), o yüzden `open` `onShow` yerine `suggestions`
 * doluluğuna göre senkron güncellenir. Kapanışta `onHide` yeterlidir (geç kapanma göze batmaz).
 */
export default function MobileSheetAutoComplete<T = unknown, M extends boolean = false>(
  props: Readonly<AutoCompleteProps<T, M>>,
) {
  const ref = useRef<AutoComplete<T, M>>(null)
  const [open, setOpen] = useState(false)
  const { panelClassName, onShow, onHide, suggestions, ...rest } = props

  useEffect(() => {
    setOpen(Boolean(suggestions && suggestions.length > 0))
  }, [suggestions])

  useEffect(() => {
    if (!open) return
    document.body.classList.add('ui-mobile-sheet-lock')
    return () => document.body.classList.remove('ui-mobile-sheet-lock')
  }, [open])

  return (
    <>
      <AutoComplete
        {...rest}
        suggestions={suggestions}
        ref={ref}
        panelClassName={panelClassName ? `${panelClassName} ui-mobile-sheet` : 'ui-mobile-sheet'}
        onShow={onShow}
        onHide={() => {
          setOpen(false)
          onHide?.()
        }}
      />
      {open && (
        <div
          className="ui-mobile-sheet-backdrop"
          onClick={() => {
            setOpen(false)
            ref.current?.hide()
          }}
          aria-hidden="true"
        />
      )}
    </>
  )
}
